import { AbstractControl } from '@angular/forms';
import {
  exclusionCategoryEnum,
  xLunchFactor
} from '@exclusionmodule/constants';

export function resetErrorMessageForDateControls(
  startDate,
  endDate,
  endMonitorDate,
  dateOffRoll,
  inputControlName,
  isStartDateIsNonSchoolDate
) {
  // Clear Error message is start date having
  // 1. Start date is having validation message for endDate is greather then startDate && startDate is not a nonSchool date "
  // 2. Start date not overlapping Permanent Exclusion
  if (
    startDate.hasError('isInvalidStartDate') &&
    !isStartDateIsNonSchoolDate &&
    !startDate.hasError('isOverlappedWithPermExclusion')
  ) {
    if (
      new Date(startDate.value).getTime() <= new Date(endDate.value).getTime()
    ) {
      startDate.setErrors(null);
    }
  }
  if (
    (endDate.hasError('isInvalidEndDate') ||
      endDate.hasError('dateBeforeExclStartDate')) &&
    !endDate.hasError('isOverlappedWithPermExclusion')
  ) {
    endDate.setErrors(null);
  }
  if (
    endMonitorDate.hasError('isInvalidMonitorDate') ||
    endMonitorDate.hasError('invalidDateFormat') ||
    endMonitorDate.hasError('dateBeforeExclStartDate')
  ) {
    endMonitorDate.setErrors(null);
  }
  if (
    inputControlName === 'startDate' &&
    dateOffRoll.hasError('isDateOffRollBeforeStartDate')
  ) {
    dateOffRoll.setErrors(null);
  }
}

export function customDateComparerValidator(control: AbstractControl) {
  if (control.parent) {
    const formGroup = control.parent.controls;
    const startDate = formGroup['startDate'];
    const endDate = formGroup['endDate'];
    const endMonitorDate = formGroup['endMonitorDate'];
    const dateOffRoll = formGroup['dateOffRoll'];
    const inputControlName = Object.keys(formGroup).find(
      (name) => control === formGroup[name]
    );

    let isStartDateIsNonSchoolDate = false;
    if (startDate.value && inputControlName === 'endDate') {
      isStartDateIsNonSchoolDate = this.isStartDateIsNonSchoolDate();
    }

    resetErrorMessageForDateControls(
      startDate,
      endDate,
      endMonitorDate,
      dateOffRoll,
      inputControlName,
      isStartDateIsNonSchoolDate
    );

    if (
      startDate.value &&
      endDate.value &&
      new Date(startDate.value).getTime() > new Date(endDate.value).getTime()
    ) {
      return inputControlName == 'startDate'
        ? { isInvalidStartDate: true }
        : { isInvalidEndDate: true };
    }

    //To check if new/edit exclusion start date is overlapping permanent exclusion
    if (inputControlName === 'startDate' && startDate.value) {
      const isOverlapped: boolean = this.checkIfPermanentExclusionOverlapped(
        startDate.value
      );
      if (isOverlapped) {
        return { isOverlappedWithPermExclusion: true };
      }
    }
    //To check if new/edit exclusion end date is overlapping permanent exclusion
    if (inputControlName === 'endDate' && endDate.value) {
      const isOverlapped: boolean = this.checkIfPermanentExclusionOverlapped(
        endDate.value
      );
      if (isOverlapped) {
        return { isOverlappedWithPermExclusion: true };
      }
    }

    if (
      (startDate.value &&
        endMonitorDate.value &&
        new Date(startDate.value).getTime() >
          new Date(endMonitorDate.value).getTime()) ||
      (endDate.value &&
        endMonitorDate.value &&
        new Date(endDate.value).getTime() <
          new Date(endMonitorDate.value).getTime())
    ) {
      if (inputControlName == 'endMonitorDate') {
        return { isInvalidMonitorDate: true };
      } else {
        formGroup['endMonitorDate'].setErrors({ isInvalidMonitorDate: true });
      }
    }

    //To check if new/edit exclusion start date is greater than date off roll
    if (
      inputControlName === 'startDate' &&
      startDate.value &&
      dateOffRoll.value &&
      new Date(startDate.value).getTime() >
        new Date(dateOffRoll.value).getTime()
    ) {
      return { isStartDateAfterDateOffRoll: true };
    }
  }

  return null;
}

export function customReInstateDateComparerValidator(control: AbstractControl) {
  if (control.parent) {
    const formGroup = control.parent.controls;
    const startDate = formGroup['startDate'];
    const endDate = formGroup['endDate'];
    const reinstateDate = formGroup['reinstateDate'];
    const inputControlName = Object.keys(formGroup).find(
      (name) => control === formGroup[name]
    );

    reinstateDate.setErrors(null);

    if (
      startDate.value &&
      reinstateDate.value &&
      new Date(startDate.value).getTime() >
        new Date(reinstateDate.value).getTime()
    ) {
      return { isInvalidReinstateDateStart: true };
    } else if (
      endDate.value &&
      reinstateDate.value &&
      new Date(endDate.value).getTime() <
        new Date(reinstateDate.value).getTime()
    ) {
      if (inputControlName == 'endDate') {
        formGroup['reinstateDate'].setErrors({
          isInvalidReinstateDateEnd: true
        });
      } else {
        return { isInvalidReinstateDateEnd: true };
      }
    }
  }

  return null;
}

export function customWithdrawnDateComparerValidator(control: AbstractControl) {
  if (control.parent) {
    const formGroup = control.parent.controls;
    const startDate = formGroup['startDate'];
    const withdrawnDate = formGroup['withdrawnDate'];

    withdrawnDate.setErrors(null);

    if (
      startDate.value &&
      withdrawnDate.value &&
      new Date(startDate.value).getTime() >
        new Date(withdrawnDate.value).getTime()
    ) {
      return { isInvalidWithdrawnDate: true };
    }
  }

  return null;
}

export function customOffsetDateValidator(control: AbstractControl) {
  const offset = control.value;

  //check offset value must be in increments of 0.5
  if (offset > 0) {
    if (offset % xLunchFactor.DEFAULT != 0) {
      // not multiple of 0.5.
      return { isOffsetInputInvalid: true };
    }

    let days;
    if (
      this.selectedCategoryExternalCode ==
      exclusionCategoryEnum.EXT_CODE_LUNCHTIME
    ) {
      days = this.numberOfLunchtimesWithLunchFactor;
    } else {
      days = this.excludedDaysLessNonSchoolDays;
    }
    //offset should not be more the excluded days
    if (offset >= days) {
      return { isInvalidOffset: true };
    }
  }

  return null;
}

export function customDateOffROllValidator(control: AbstractControl) {
  if (control.parent) {
    const formGroup = control.parent.controls;
    const startDate = formGroup['startDate'];
    const dateOffRoll = formGroup['dateOffRoll'];

    dateOffRoll.setErrors(null);
    if (startDate.hasError('isStartDateAfterDateOffRoll')) {
      startDate.setErrors(null);
    }
  }

  return null;
}
